import { MenuProps } from "antd";

export const navbarMenuItems: MenuProps["items"] = [
  {
    label: "Odjava",
    key: "logout",
  },
];